import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var SortIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ _jsx("path", {
            d: "M14.862 4.471a.667.667 0 0 0 .943-.942L12.47.195a.667.667 0 0 0-.942 0L8.195 3.53a.667.667 0 1 0 .943.942l2.195-2.195v13.057a.667.667 0 0 0 1.334 0V2.276l2.195 2.195ZM1.138 11.529a.667.667 0 1 0-.943.942l3.334 3.334a.666.666 0 0 0 .942 0l3.334-3.334a.667.667 0 1 0-.943-.942l-2.195 2.195V.667a.667.667 0 0 0-1.334 0v13.057l-2.195-2.195Z"
        }) : /*#__PURE__*/ _jsx("path", {
            d: "m10.47 17.47-3.72 3.72V.75a.75.75 0 0 0-1.5 0v20.44l-3.72-3.72a.75.75 0 0 0-1.06 1.06l5 5a.75.75 0 0 0 1.06 0l5-5a.75.75 0 1 0-1.06-1.06ZM22.47 6.53a.75.75 0 1 0 1.06-1.06l-5-5a.75.75 0 0 0-1.06 0l-5 5a.75.75 0 0 0 1.06 1.06l3.72-3.72v20.44a.75.75 0 0 0 1.5 0V2.81l3.72 3.72Z"
        })
    }));
};
